import React, { FC } from 'react';
import { Medium } from "@/constants/mediums";
import ReadingsDetailPage from "@/components/readings/ReadingsDetailPage";

const WaterReadingsDetailPage: FC = () => {
  return <ReadingsDetailPage medium={Medium.water} />;
};

export default WaterReadingsDetailPage;
